<template>
    <div class="row">
        <div class="col-3 form-group">
            <division-dropdown
                v-if="divisionList"

                :division-list="divisionList"
                :value="divisionId"

                @input="selectDivisionId($event)"
            />
        </div>
        
        <div class="col-12 form-group">
            <div class="box">
                <template v-if="hasActive">
                    <div class="box-header">
                        <h3 class="box-title">{{resource('DmVisualizer_Overview_BoxTitle')}}</h3>
                        <br />
                        <span v-html="titleBodyText"></span>
                    </div>

                    <div class="box-body">
                        <scenario-active-overview
                            v-bind:scenario-batches="activeScenarioBatchList.scenarioBatches"
                            @batches-updated="replaceActiveScenarioBatches($event.scenarioId, $event.batches)"
                        >
                        </scenario-active-overview>
                    </div>
                </template>

                <template v-if="hasHistory">
                    <div class="box-header">
                        <h3 class="box-title">{{resource('DmVisualizer_Overview_History_BoxTitle')}}</h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-6">
                                <scenario-historical-overview
                                    v-bind:scenario-batches="historicalScenarioBatchList.scenarioBatches"
                                    v-bind:from-date="historicalScenarioBatchList.periodStart"
                                    v-bind:to-date="historicalScenarioBatchList.periodEnd"
                                    v-bind:target-date="historicalScenarioBatchList.targetDate"
                                ></scenario-historical-overview>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import formatDateMixin from '../Mixins/format-date-mixin';
    import sortScenariosMixin from '../Mixins/sort-scenarios-mixin';
    import resourceMixin from '../../../Util/Mixins/resources';
    
    import sprintf from 'sprintf';
    import divisionApi from '@core/Api/divisions';
    import dmVisualizerApi from '../../../Api/dm-visualizer';
    import growler from "../../../Util/growler";
    import loader from '@core/Util/loader';
    
    import DivisionDropdown from '@core/Components/Util/DivisionDropdown';

    import ScenarioList from "./ScenarioList.vue";
    import ScenarioActiveOverview from "./Overview/ScenarioActiveOverview.vue";
    import ScenarioBatchListItem from "./Overview/ScenarioBatchListItem.vue";
    import ScenarioHistoricalOverview from "./Overview/ScenarioHistoricalOverview.vue";
    
    export default {
        name: "dm-visualizer-overview",
        
        mixins: [sortScenariosMixin, resourceMixin, formatDateMixin],
        
        components: {
            DivisionDropdown,
            
            ScenarioList,
            ScenarioBatchListItem,
            ScenarioActiveOverview,
            ScenarioHistoricalOverview
        },
        
        props: {
            divisionId: {
                type: String,
                required: false,
                default: undefined
            }
        },

        data: () => ({
            activeScenarioBatchList: [],
            historicalScenarioBatchList: {},
            customerContactEmail: undefined,
            divisionList: undefined
        }),
        
        computed: {
            hasHistory(){
                return this.historicalScenarioBatchList.scenarioBatches && 
                    this.historicalScenarioBatchList.scenarioBatches.length;
            },
            hasActive(){
                return this.activeScenarioBatchList.scenarioBatches &&
                    this.activeScenarioBatchList.scenarioBatches.length;
            },
            titleBodyText(){
                //Can't format a string with date we don't have
                if(!this.hasActive) return undefined;
                
                const baseString = this.resource('DmVisualizer_Overview_BoxTitleBody');
                const {periodStart, periodEnd, targetDate} = this.activeScenarioBatchList;
                
                return sprintf(
                    baseString,
                    this.formatDate(periodStart),
                    this.formatDate(periodEnd),
                    this.formatDate(targetDate),
                    this.customerContactEmail ? `<a href="mailto:${this.customerContactEmail}">${this.customerContactEmail}</a>` : ''
                )
            }
        },

        created() {
          const vm = this;
          
            dmVisualizerApi.setDivisionId(vm.divisionId);
            
            dmVisualizerApi.getCustomerContactEmail().then(
                email => vm.customerContactEmail = email,
                () => {}
            );

            divisionApi.getDivisionsList().then(
                divisionList => vm.divisionList = divisionList,
                err => growler.bootstrapDanger(err)
            );

            vm.loadDisplayedBatches();
        },

        methods: {
            async selectDivisionId(divisionId) {
                if(this.divisionId === divisionId) {
                    return;
                }

                await this.$router.push({
                    name: this.$route.name,
                    query: { divisionId: divisionId }
                });

                dmVisualizerApi.setDivisionId(this.divisionId);

                //Wait for route based prop to update
                this.$nextTick();
                await this.loadDisplayedBatches();
            },

            replaceActiveScenarioBatches(scenarioId, batches){
                const vm = this;

                //Replacing all batches with our given scenarioId should do the trick and trigger a re-render
                const newScenarioBatches = vm.activeScenarioBatchList.scenarioBatches
                    .filter(b => b.scenarioId !== scenarioId);

                newScenarioBatches.push(...batches);
                vm.activeScenarioBatchList.scenarioBatches = newScenarioBatches;
            },
            
            async loadDisplayedBatches() {
                try {
                    loader.show();
                    
                    await this.$nextTick();

                    this.activeScenarioBatchList = await dmVisualizerApi.listActiveBatches();
                    this.historicalScenarioBatchList = await dmVisualizerApi.listHistoricalBatches();
                } catch (e) {
                    growler.bootstrapDanger(e);
                } finally {
                    loader.hide();
                }
            }
        }
    };
</script>
